import { render, staticRenderFns } from "./AddTagsModal.vue?vue&type=template&id=fa510180&scoped=true&"
import script from "./AddTagsModal.vue?vue&type=script&lang=js&"
export * from "./AddTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagsModal.vue?vue&type=style&index=0&id=fa510180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa510180",
  null
  
)

export default component.exports